import { useMutation } from '@tanstack/react-query';
import { getDasContributionsStatement } from '../../../services/das.service';

export const useDasContributionsStatement = () => {
  return useMutation({
    mutationFn: getDasContributionsStatement,
  });
};
